import { render, staticRenderFns } from "./SignInTwoFactor.vue?vue&type=template&id=66e8c38a&"
import script from "./SignInTwoFactor.vue?vue&type=script&lang=ts&"
export * from "./SignInTwoFactor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports